import { RootState } from "../../reducers";

export const unsavedDocumentChangesDataSelector = (
  state: RootState
): RootState["documentSaving"] => state.documentSaving;

export const documentIdToChangeToSelector = (state: RootState): string =>
  state.documentSaving.documentIdToChangeTo;
